module.exports = __webpack_public_path__ + "img/06-install-step-1-download.6c5cda4c.webp";